import React from "react"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import {RouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"

const NoStock = () => (
  <>
    <Body>
      <FormattedMessage id="perks.components.productForms.noStock.description" />
      <RouterLink to="/">
        <FormattedMessage id="perks.components.productForms.noStock.desc.link" />
      </RouterLink>
    </Body>
    <Flex justifyContent="center" marginTop={4}>
      <RouterLink to="/">
        <Flex alignItems="center">
          <FormattedMessage id="perks.components.productForms.noStock.discover" />
          <Icon icon={IconTypes.arrowRight} marginLeft />
        </Flex>
      </RouterLink>
    </Flex>
  </>
)

export default NoStock
